//////////////////////
//// GET ENVIRONMENT FILE AND CALL CONFIGURE REST WITHOUT JQUERY START ////
//////////////////////

var request = new XMLHttpRequest();
request.open("get", "/assets/scripts/environment.json", true);
request.onload = function (r) {
    console.info("Environment File Loaded");
    var env = JSON.parse(r.currentTarget.response);
    configureRest(env);
    // console.log(r.currentTarget.response);
}
request.onerror = function (e) {
    console.info("Error Loading Environment File");
    console.log(e)
}
request.send(null);

//////////////////////
//// GET ENVIRONMENT FILE AND CALL CONFIGURE REST WITHOUT JQUERY END ////
//////////////////////

function configureRest(variables) {

    //////////////////////
    //// AXIOS CONFIG ////
    //////////////////////

    window.rest = axios.create({
        baseURL: variables.app_server_url,
        timeout: 15000,
        headers: {}
    });

    window.rest.environment = {};

    window.rest.environment.name = variables.environment;
    window.rest.environment.branch = variables.branch;
    window.rest.environment.server_url = variables.app_server_url;
    window.rest.environment.app_frontend_url = variables.app_frontend_url;
    window.rest.environment.stripe_public = variables.stripe_public;

    // window.rest.identify = function(email, payload) {
    // try {
    //     if (variables.logrocket && window.LogRocket) {
    //         window.LogRocket.identify(email, payload);
    //     }
    //     if (variables.fullstory && window.FS) {
    //         FS.identify(email, {displayName: email, email:email, userInfo: payload});
    //     }
    //     if (variables.amplitude && window.amplitude) {
    //         payload.branch = window.rest.environment.branch;
    //         window.amplitude.getInstance().setUserId(email);
    //         window.amplitude.getInstance().setUserProperties(payload);
    //     }
    // } catch (error) {
    //     console.log(error);
    // }
    // }

    window.rest.injectUser = function (user) {
        window.cardsShopContent && (window.cardsShopContent._data.user = user);
    };
    window.rest.ejectUser = function () {
        window.cardsShopContent && (window.cardsShopContent._data.user = false);
    };

    window.rest.logOut = function () {
        window.localStorage.clear();
        window.rest.ejectUser();
        if (window.location.pathname !== "/") {
            window.location = "/";
        } else {
            window.bulmaToast.toast({
                duration: 3000,
                position: "bottom-center",
                message: '<strong class="is-size-4">You successfully logged out.</strong>',
                type: "is-success",
                dismissible: true,
            });
        }
    }

    window.rest.signup = function (e) {
        e = e || window.event;
        e.preventDefault();
        emailField = document.querySelector('input[name="email_register"]');
        passwordField = document.querySelector('input[name="password_register"]');
        var payload = {
            email: emailField.value,
            password: passwordField.value
        };
        window.rest.post(
            'users/open',
            payload
        ).then(function (user) {
            console.log(user);
            window.bulmaToast.toast({
                duration: 10000,
                position: "bottom-center",
                message: '<strong class="is-size-4">Check your email inbox to complete registration.</strong>',
                type: "is-success",
                dismissible: true,
            });
        }).catch(function (error) {
            console.log(error);
            window.bulmaToast.toast({
                duration: 3000,
                position: "bottom-center",
                message: '<strong class="is-size-4">Invalid email/password, or user is already registered.</strong>',
                type: "is-danger",
                dismissible: true,
            });
        }).finally(function () {
            emailField.value = '';
            passwordField.value = '';
            setTimeout(function () {
                window.location = "/login";
            }, 2000);
        })
    };

    window.rest.login = function (e) {
        e = e || window.event;
        e.preventDefault();
        emailField = document.querySelector('input[name="email_login"]');
        passwordField = document.querySelector('input[name="password_login"]');
        var params = new URLSearchParams();
        params.append('username', emailField.value);
        params.append('password', passwordField.value);
        window.rest.post(
                '/login/access-token',
                params
            )
            .then(function (response) {
                return window.localStorage.setItem("access_token", response.access_token);
            })
            .then(function () {
                return window.rest.get("users/me");
            })
            .then(function (response) {
                window.localStorage.setItem("cached_user", JSON.stringify(response));
                window.rest.injectUser(response);
                return response;
            })
            .then(function (user) {
                console.log(user);
                window.bulmaToast.toast({
                    duration: 4000,
                    position: "bottom-center",
                    message: '<strong class="is-size-4">You are now logged in as: ' + user.email.split("@")[0] + '.' + '</strong>',
                    type: "is-success",
                    dismissible: true,
                });
            }).catch(function (error) {
                console.log(error);
                window.bulmaToast.toast({
                    duration: 3000,
                    position: "bottom-center",
                    message: '<strong class="is-size-4">Email or password are invalid.</strong>',
                    type: "is-danger",
                    dismissible: true,
                });
            }).finally(function () {
                emailField.value = '';
                passwordField.value = '';
                setTimeout(function () {
                    window.location = "/";
                }, 1000);
            })
    };

    window.rest.recover = function (e) {
        e = e || window.event;
        e.preventDefault();
        emailField = document.querySelector('input[name="email_recover"]');
        window.rest.post(
            'password-recovery/' + encodeURIComponent(emailField.value)
        ).then(function (user) {
            console.log(user);
            window.bulmaToast.toast({
                duration: 10000,
                position: "bottom-center",
                message: '<strong class="is-size-4">Check your email inbox to complete password recovery.</strong>',
                type: "is-success",
                dismissible: true,
            });
        }).catch(function (error) {
            console.log(error);
            window.bulmaToast.toast({
                duration: 3000,
                position: "bottom-center",
                message: '<strong class="is-size-4">User not present.</strong>',
                type: "is-danger",
                dismissible: true,
            });
        }).finally(function () {
            emailField.value = '';
            setTimeout(function () {
                window.location = "/";
            }, 2000);
        })
    };

    // window.rest.terminate = function(element) {
    //     var payload = {};
    //     window.rest.post('users/' + JSON.parse(window.localStorage.getItem("current_user"))["id"] + '/make-inactive')
    //         .then(function (response) {
    //             window.localStorage.clear();
    //             window.location = "/";
    //         })
    //         .catch(function (error) {
    //             console.log('Error in terminating account');
    //         });
    // }

    window.rest.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    function capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    window.rest.interceptors.request.use(function (config) {
        if (window.localStorage.getItem("access_token")) {
            //!!! here below is the point that will break because of sebastian, 
            // change b with B as soon as  THIS  he will deploy !!!//
            config.headers.Authorization = "bearer " + window.localStorage.getItem("access_token");
            config.headers['Cache-Control'] = "no-cache,no-store,must-revalidate,max-age=-1,private";
            console.log("Authorized Request")
        } else {
            console.log("Unauthorized Request")
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });

    window.rest.interceptors.response.use(function (response) {

        if (!response.data.image_url) {
            response.data.image_url = "/assets/static/images/common/stubs/user.png";
        };

        if (response.config.url === (response.config.baseURL + '/users/me')) {
            if (!response.data.addresses.length) {
                response.data.addresses.push({
                    "country": "",
                    "region": "",
                    "city": "",
                    "city_zone": "",
                    "address_line_1": "",
                    "address_line_2": "",
                    "zip_code": "",
                    "phone_Number": "",
                });
            };
        }
        if (window.rest.environment.name === "production") {
            // try {
            //     if (response.data.id && response.data.email) {
            // console.log(response.data.email, response.data)
            // window.rest.identify(response.data.email, response.data);
            //     }
            // } catch(e) {
            //     console.error("Analytics could not identify user")
            // }
        }
        return response.data;
    }, function (error) {
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
        console.log("Request to: " + error.request.responseURL + " failed with following info:");
        if (error.response) {
            console.log(error.response.status);
            console.log(error.response.data.message);
        } else {
            console.log(error)
        }
        console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<')
        var hint = "";
        if (error.response) {
            if (!error.response.data.message || typeof (error.response.data.message) === undefined) {
                hint = "Ouch, it looks like server is currently unavailable."
            } else if ((typeof error.response.data.message) === "string") {
                hint = capitalize(error.response.data.message);
            } else if ((typeof error.response.data.message) === "object") {
                hint = capitalize(error.response.data.message[Object.keys(error.response.data.message)[0]])
            }
            return Promise.reject({
                status: error.response.status,
                message: hint
            });
        } else {
            return Promise.reject({
                status: error,
                message: error
            });
        }
    });

    //////////////////////
    //// GET PARAMETERS //
    //////////////////////

    window.rest.getParameterByName = function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    ///////////////////////////
    //// UTILITIES FUNCTIONS //
    ///////////////////////////

    window.rest.intersection = function (a, b) {
        var d = {};
        var results = [];
        for (var i = 0; i < b.length; i++) {
            d[b[i]] = true;
        }
        for (var j = 0; j < a.length; j++) {
            if (d[a[j]])
                results.push(a[j]);
        }
        return results;
    }
    window.rest.getFieldByValue = function (value, key_to_compare, key_to_get, array) {
        var v = false;
        array.forEach(function (object) {
            if (object[key_to_compare] == value) {
                // if !!key_to_get return all object
                v = key_to_get ? object[key_to_get] : object;
            }
        });
        return v;
    }

    window.rest.isValidURL = function(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    // CREATE AXIOS INSTANCE TO FETCH DATA FROM FRONTEND FILES START
    var frontUrl = window.location.origin + '/' || variables.app_frontend_url;
    window.frontrest = axios.create({
        baseURL: frontUrl,
        timeout: 15000,
        headers: {}
    });
    window.frontrest.interceptors.response.use(function (response) {
        return response.data;
    }, function (error) {
        console.log("FrontRest Error")
        console.log(error)
    });

    // CREATE AXIOS INSTANCE TO FETCH DATA FROM FRONTEND FILES END

    console.log("Axios available at window.rest:")
    console.log(window.rest.environment)
    window.pageBootstrap && window.pageBootstrap();

}


//////////////////
// WEBPACK FOOTER
// ./assets/scripts/rest.js
// module id = 2
// module chunks = 1